import A4 from 'PdfPages/pages/A4';
import { useEffect } from 'react';
import useQuery from 'utils/getQueryParams';
import { connect } from 'react-redux';
import { IReducer } from 'Reducers/IReducer';
import { bindActionCreators } from 'redux';
import { ILaboratoryDetails } from 'Reducers/LaboratoryReducer/ILaboratoryReducer';
import { GeneralFieldsValue } from 'PdfPages/components/GeneralFields';
import { searchSample } from 'actions/LaboratoryActions';
import './print.css';
import { ICustomer, ISample } from 'exactt-types/lib';
import moment from 'moment';
import Papa from 'papaparse';
import { Button } from '@mui/material';

interface SampleAllPrintProps {
  setDisableScroll: (value: boolean) => void;
  searchSample: (
    laboratoryId: string,
    params: {
      page?: number;
      size?: number;
      query?: string;
      startDate?: string;
      endDate?: string;
      testGroup?: string;
      customer?: string;
      status?: string;
      sortByCustomer?: boolean;
    }
  ) => Promise<any>;
  sampleList: ISample[] | [];
  laboratory: ILaboratoryDetails | null;
}

export function _SampleRegister(props: SampleAllPrintProps) {
  let query = useQuery();
  const selectedStartDate = (query.get('startDate') || query.get('from')) as string;
  const selectedEndDate = (query.get('endDate') || query.get('to')) as string;
  const selectedTestGroup = (query.get('testGroup') || query.get('group')) as string;
  const selectedCustomer = query.get('customer') as string;
  const selectedGroupName = query.get('groupName') as string;

  const normalizedTestGroup = selectedTestGroup === 'undefined' ? undefined : selectedTestGroup;
  const normalizedCustomer = selectedCustomer === 'undefined' ? undefined : selectedCustomer;

  const onFocus = async () => {
    const searchQuery = query.get('query') || '';
    const sortByCustomer = query.get('sortByCustomer') === 'true';
    const status = query.get('status') || undefined;

    await props.searchSample(props.laboratory?.details?._id || '', {
      page: 1,
      size: 2000,
      query: searchQuery,
      startDate: selectedStartDate,
      endDate: selectedEndDate,
      testGroup: normalizedTestGroup,
      customer: normalizedCustomer,
      status: status,
      sortByCustomer: sortByCustomer,
    });
  };

  useEffect(() => {
    props.setDisableScroll(true);
    onFocus();
    // eslint-disable-next-line
  }, []);

  const values: GeneralFieldsValue[] = [];

  const startDate = moment(selectedStartDate).format('DD/MM/YYYY');
  const endDate = moment(selectedEndDate).format('DD/MM/YYYY');

  const downloadCSV = () => {
    const sampleData = props.sampleList.map((sample, index) => ({
      'Sr. No': index + 1,
      'Date of Receipt': moment(sample?.collectionDate).format('DD/MM/YYYY'),
      'Lab ID': sample?.sampleId,
      'Name of Customer': (sample?.customer as ICustomer)?.name || 'N/A',
      'Sample Name': sample?.name || 'NA',
      'Test Required': sample?.testMethod || 'NA',
      'Received Quantity': sample?.sampleQty,
    }));

    try {
      const csv = Papa.unparse(sampleData);
      const blob = new Blob([csv], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `SampleRegister_${startDate}_to_${endDate}.csv`;
      link.click();
    } catch (error) {
      console.error('Error generating CSV:', error);
    }
  };

  return (
    <A4
      header={
        <>
          <Button onClick={downloadCSV} variant="outlined" style={{ marginTop: 10 }}>
            Download CSV
          </Button>
          {props.laboratory && (
            <>
              <h2 style={{ marginBottom: 2 }}>{props.laboratory.details.name}</h2>
              <div>
                Sample Entry Report for the period from {''}
                {startDate} to {endDate}
              </div>
              {normalizedTestGroup ? <div>Group Name: {selectedGroupName || 'N/A'}</div> : null}
            </>
          )}
        </>
      }
      landscape={true}
      body={
        <>
          <table style={{ width: '100%', marginTop: 5 }}>
            <thead style={{ border: '1px solid black' }}>
              <tr>
                <th colSpan={7} style={{ borderTop: '1px solid black' }}></th>
              </tr>
              <tr>
                <th
                  style={{
                    textAlign: 'left',
                    width: '3%',
                  }}
                >
                  Sr. No
                </th>
                <th
                  style={{
                    textAlign: 'left',
                    width: '3%',
                  }}
                >
                  Date of Receipt
                </th>
                <th
                  style={{
                    textAlign: 'left',
                    width: '8%',
                  }}
                >
                  Lab ID
                </th>
                <th
                  style={{
                    textAlign: 'left',

                    width: '8%',
                  }}
                >
                  Name of Customer
                </th>
                <th
                  style={{
                    textAlign: 'left',
                    width: '8%',
                  }}
                >
                  Sample Name
                </th>
                <th
                  style={{
                    textAlign: 'left',
                    width: '10%',
                  }}
                >
                  Test Required
                </th>
                <th
                  style={{
                    textAlign: 'left',
                    width: '8%',
                  }}
                >
                  Recieved Quantity
                </th>
              </tr>
              <tr>
                <th colSpan={7} style={{ borderTop: '1px solid black' }}></th>
              </tr>
            </thead>
            <tbody>
              {props.sampleList.map((sample, index) => (
                <tr key={sample?._id || index}>
                  <td>{index + 1}</td>
                  <td>{moment(sample?.collectionDate).format('DD/MM/YYYY')}</td>
                  <td>{sample?.sampleId}</td>
                  <td>{(sample?.customer as ICustomer)?.name || 'N/A'}</td>
                  <td>{sample?.name || 'NA'}</td>
                  <td>{sample?.testMethod || 'NA'}</td>
                  <td>{sample?.sampleQty}</td>
                </tr>
              ))}
              {!props.sampleList.length ? (
                <tr>
                  <td colSpan={7} style={{ textAlign: 'center', padding: '12px' }}>
                    No sample data found for the selected filters.
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </>
      }
      footer={
        <div style={{ borderTop: '1px solid black' }}>
          <div id="page-number"></div>
        </div>
      }
    />
  );
}

const mapStateToProps = (state: IReducer) => ({
  laboratory: state.laboratory.current,
  sampleList: state.laboratory.samples,
});

function mapDispatchToProps(dispatch: any) {
  return {
    ...bindActionCreators({ searchSample }, dispatch),
  };
}

export const SampleRegister = connect(mapStateToProps, mapDispatchToProps)(_SampleRegister);
